import { Avatar, Card, CardContent, Grid, Typography } from "@mui/material";
import { indigo } from "@mui/material/colors";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

const TotalProfit = (props) => (
  <Card {...props} sx={{ background: '#eee'}}>
    <CardContent>
      <Grid container spacing={3} sx={{ justifyContent: "space-between" }}>
        <Grid item>
          <Typography color="textSecondary" gutterBottom variant="h6">
            총환급액(개발중)
          </Typography>
          <Typography color="textPrimary" variant="h3">
            ￦170,246,200
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            sx={{
              backgroundColor: indigo[600],
              height: 56,
              width: 56,
            }}
          >
            <AttachMoneyIcon />
          </Avatar>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default TotalProfit;
